export default {
  userToken: "token",
  userEmail: "userEmail",
  mlogData: "localMlogDataCopyKey",
};
